import { Materials } from "./components/materials/Materials";

export function App() {
  return (
    <>
      <Materials />
    </>
  );
}